export default __webpack_public_path__ + "static/media/UKTOP10.01ffe513.png";